module.exports = __webpack_public_path__ + "img/IMG-20200227-WA0356.38f55fe4.jpg";